import type React from 'react'

import { memo } from 'react'

import type { GalleryImage as GalleryImageType } from './lib/type'

import FigureImage from './FigureImage'

interface GalleryImageProps {
  image: GalleryImageType
  isLightboxEnabled?: boolean
}

const GalleryImage = memo(
  ({
    image,
    isLightboxEnabled = true,
  }: Readonly<GalleryImageProps>): React.JSX.Element => {
    if (isLightboxEnabled) {
      return (
        <a className="relative block" data-fancybox="gallery" href={image.url}>
          <FigureImage image={image} />
        </a>
      )
    }

    return <FigureImage image={image} />
  },
)

GalleryImage.displayName = 'GalleryImage'

export default GalleryImage
